import { compose } from '../../../app/app';
import TopLoadingBar from './TopLoadingBar';

const props = (state) => state['top.loading.bar'];

export default compose(TopLoadingBar, { props });
